import { type ShipmentTrackingStatus } from '../domain/Shipment'

export function formatAssignDriverDialogTitle(driverUUID?: string) {
  return driverUUID ? 'Edit driver' : 'Choose the driver'
}

export function formatAssignTruckDialogTitle(tractorNumber?: string) {
  return tractorNumber ? 'Edit truck' : 'Choose the truck'
}

export function formatLocationPingEmptyStateTitle(trackingStatus: ShipmentTrackingStatus) {
  if (trackingStatus === 'not-started') {
    return 'No location pings received'
  }

  if (trackingStatus === 'not-tracking') {
    return 'Load not tracking?'
  }
}
